export default {
    addDashboard: "Añadir dashboard",
    saveDashboard: "Dashboard guardado correctamente",
    dashboardButtons: {
        filters: "Filtros",
        zoom: "Zoom",
        remove: "Eliminar",
        move: "Mover",
        edit: "Editar",
        save: "Guardar",
        close: "Cerrar",
        addGraph: "Añadir componente",
        configure: "Configurar",
    },
    deleteModal: {
        title: 'Eliminar Dashboard',
        body: '¿Estás seguro de que quieres eliminar el dashboard "{dashboardName}"?',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
    },
    filters: {
        title: 'Elige los filtros a aplicar',
        labels: {
            generalFilters: 'Filtros generales',
            dashboardFilters: 'Filtros de dashboard',
            graphFilters: 'Filtros individuales',
            noFilters: 'No hay filtros aplicados',
        },
        addFilter: 'Añadir filtro',
        addedFilter: 'Este filtro ya fue añadido',
    },
    editNameModal: {
        title: 'Renombrar gráfica',
        rename: 'Renombrar',
    },
    graphTitles: {
        VARIANTS: 'Variantes',
        TRANSITIONS: 'Transiciones',
        ACTIVITIES: 'Actividades',
        ATTRIBUTE: 'Atributo',
        OTHERS: 'Otros',
    },
    graphSubtitles: {
        FREQUENCY: 'Frecuencia',
        frequencyvsaverage: 'Variantes según frecuencia y duración',
        DURATION_AVG: 'Duración media',
        DURATION_MAX: 'Duración máxima',
        DURATION_MIN: 'Duración mínima',
        DURATION_STD: 'Desviación estándar del tiempo',
        attributeInformation: 'Análisis estándar',
        FREQUENCY_AND_DURATION: 'Frecuencia y duración',
    },
    filterTags: {
        own: "Gráfico",
        dashboard: "Dashboard",
        general: "General",
    },
}
